export class RejectAuthoriseConstants {
    static REJECT_AUTHORISE_FORM_CONTROL = "rejectAuthorise";
    static TITLE_LABEL = "Reject Authorisation";
    static REJECT_AUTHORISE_LABEL = "Rejection reason";
    static CONTINUE_BTN_LABEL = "Continue";
}
export const VALIDATION_MESSAGE = {
    rejectAuthorise: {
        required: `Rejection Reason Required`
    },
};
